/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_TournamentsInputs */



/**
* | output |
* | --- |
* | "Tournaments" |
*
* @param {Nav_TournamentsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nav_tournaments = /** @type {((inputs?: Nav_TournamentsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_TournamentsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tournois")
	if (locale === "es") return /** @type {LocalizedString} */ ("Torneos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Torneios")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tornei")
	return /** @type {LocalizedString} */ ("Tournaments")
});